var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLvl0(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "#000000",
    id: "svg48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none",
    id: "path44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z",
    id: "path46"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ff00",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,18 V 17.005988 H 12 20.994012 V 18 18.994012 H 12 3.005988 Z",
    id: "path227"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,14 V 13.005988 H 12 20.994012 V 14 14.994012 H 12 3.005988 Z",
    id: "path345"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,14 V 13.005988 H 12 20.994012 V 14 14.994012 H 12 3.005988 Z",
    id: "path416"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,10 V 9.005988 H 12 20.994012 V 10 10.994012 H 12 3.005988 Z",
    id: "path418"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,6 V 5.005988 H 12 20.994012 V 6 6.994012 H 12 3.005988 Z",
    id: "path420"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      strokeWidth: 0.0239521
    },
    d: "m 3.004936,17.997226 v -0.994012 h 8.994012 8.994012 v 0.994012 0.994012 H 11.998948 3.004936 Z",
    id: "path491"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,10 V 9.005988 H 12 20.994012 V 10 10.994012 H 12 3.005988 Z",
    id: "path493"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,6 V 5.005988 H 12 20.994012 V 6 6.994012 H 12 3.005988 Z",
    id: "path495"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,6 V 5.005988 H 12 20.994012 V 6 6.994012 H 12 3.005988 Z",
    id: "path497"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      fillOpacity: 1,
      strokeWidth: 0.0561814
    },
    d: "m 3.0057049,18.006139 v -0.955084 h 8.9890241 8.989024 v 0.955084 0.955083 H 11.994729 3.0057049 Z",
    id: "path396"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      fillOpacity: 1,
      strokeWidth: 0.00640654
    },
    d: "m 5.1796912,17.028595 v -0.02242 h 3.6100879 3.6100879 v 0.02242 0.02242 H 8.7897791 5.1796912 Z",
    id: "path398"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      fillOpacity: 1,
      strokeWidth: 0.0147284
    },
    d: "m 12.408641,17.033345 c 0,-0.0098 1.438469,-0.01473 4.285951,-0.01473 2.847483,0 4.285952,0.0049 4.285952,0.01473 0,0.0098 -1.438469,0.01473 -4.285952,0.01473 -2.847482,0 -4.285951,-0.0049 -4.285951,-0.01473 z",
    id: "path400"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      fillOpacity: 1,
      strokeWidth: 0.0147284
    },
    d: "m 14.547934,17.00757 c 1.180662,-0.0021 3.112655,-0.0021 4.293316,0 1.180662,0.0021 0.214666,0.0038 -2.146658,0.0038 -2.361323,0 -3.327319,-0.0017 -2.146658,-0.0038 z",
    id: "path402"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      fillOpacity: 1,
      strokeWidth: 0.0147284
    },
    d: "m 13.019867,17.048316 c 0.340225,-0.0042 0.60865,-0.0123 0.596499,-0.01804 -0.01215,-0.0057 0.09058,-0.0069 0.228289,-0.0026 0.318373,0.0099 5.360269,0.01085 5.714603,0.001 0.145811,-0.004 0.248541,-0.003 0.228289,0.0023 -0.02025,0.0053 0.241545,0.0131 0.58177,0.01729 0.340226,0.0042 -1.313401,0.0076 -3.674725,0.0076 -2.361323,0 -4.01495,-0.0034 -3.674725,-0.0076 z",
    id: "path404"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      fillOpacity: 1,
      strokeWidth: 0.00390625
    },
    d: "m 12.936577,17.022588 c 0.0059,-8.98e-4 0.01473,-8.74e-4 0.01953,5.3e-5 0.0048,9.27e-4 -5.3e-5,0.0017 -0.01079,0.0016 -0.01074,-2.9e-5 -0.01467,-7.88e-4 -0.0087,-0.0017 z",
    id: "path406"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      fillOpacity: 1,
      strokeWidth: 0.00390625
    },
    d: "m 12.079422,17.00293 c 0.606573,-5.45e-4 1.597979,-5.45e-4 2.203125,0 0.605146,5.44e-4 0.108859,9.9e-4 -1.102859,9.9e-4 -1.211719,0 -1.706839,-4.46e-4 -1.100266,-9.9e-4 z",
    id: "path408"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      fillOpacity: 1,
      strokeWidth: 0.00390625
    },
    d: "m 12.400391,17.029297 v -0.01953 l 0.803711,5.69e-4 c 0.442041,3.13e-4 1.113085,0.0016 1.491211,0.0029 l 0.6875,0.0024 -1.19336,0.0031 c -1.131343,0.0029 -1.775433,0.0074 -1.78034,0.01228 -0.0012,0.0012 -0.0012,0.0032 3.7e-5,0.0045 0.0012,0.0012 0.132766,0.0039 0.292287,0.0058 0.159521,0.002 0.290932,0.0045 0.292022,0.0056 0.0011,0.0011 -0.131903,0.002 -0.295542,0.002 h -0.297526 z",
    id: "path410"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      fillOpacity: 1,
      strokeWidth: 0.00390625
    },
    d: "m 10.978516,17.970703 v -0.917969 l 1.241211,-8.9e-4 c 0.682666,-4.9e-4 1.187597,-0.0018 1.12207,-0.003 l -0.119141,-0.0021 0.08789,-0.002 c 0.06209,-0.0014 0.02942,-0.0022 -0.111328,-0.0029 -0.377573,-0.0017 -0.710274,-0.0061 -0.70171,-0.0093 0.0115,-0.0043 1.359977,-0.01105 2.204639,-0.01111 l 0.678711,-4.7e-5 v 0.933594 0.933594 h -2.201171 -2.201172 z",
    id: "path412"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      fillOpacity: 1,
      strokeWidth: 0.00390625
    },
    d: "m 10.978516,17.970703 v -0.917969 l 1.172851,-8.49e-4 c 0.645069,-4.67e-4 1.15,-0.0017 1.122071,-0.0028 l -0.05078,-0.002 0.05859,-0.0022 c 0.03658,-0.0014 -0.0061,-0.0025 -0.113614,-0.003 -0.354688,-0.0017 -0.678426,-0.0061 -0.670127,-0.0092 0.0115,-0.0043 1.359975,-0.01105 2.204639,-0.01111 l 0.678711,-4.7e-5 v 0.933594 0.933594 h -2.201171 -2.201172 z",
    id: "path414"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      fillOpacity: 1,
      strokeWidth: 0.00390625
    },
    d: "m 10.978516,17.970717 v -0.917956 l 1.120117,-0.0016 c 0.639075,-9.08e-4 1.136054,-0.0031 1.157226,-0.0052 0.02948,-0.0029 0.0065,-0.0037 -0.11166,-0.0043 -0.330688,-0.0015 -0.654775,-0.0061 -0.646654,-0.0091 0.01151,-0.0043 1.35758,-0.01103 2.204603,-0.01109 l 0.678711,-4.8e-5 v 0.933594 0.933594 h -2.201171 -2.201172 z",
    id: "path417"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLvl0);
export default __webpack_public_path__ + "static/media/lvl-0.ac6b02e37078e3492a5de6411e04860a.svg";
export { ForwardRef as ReactComponent };